
// Handle scrolling to section with offset when clicking on navlinks
export const scrollToIdWithOffset = (
  id: string,
  e: React.MouseEvent<HTMLAnchorElement>,
  offset: number = 0
) => {

    // Prevent anchor default behaviors, which include populate the url with appropriate #tag
    e.preventDefault();

    const el = document.getElementById(id);
    if (!el) return;

    const y = el.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: y, behavior: 'smooth' });

    // Manually update the hash without page jump
    window.history.pushState(null, '', `#${id}`);
};